import { Button } from 'global/components/Button'
import Menu from 'global/components/Menu'
import {
    CircleXIcon,
    CreditCardIcon,
    EllipsisVerticalIcon,
    ShoppingCartIcon,
} from 'lucide-react'
import { usePlanosContext } from 'pages/Planos.context'
import ChipStatusAssinatura from './ChipStatus'

export default function HeaderAssinatura() {
    const botoes = useBotoes()

    return (
        <div className="flex w-full shrink-0 justify-between gap-2">
            <h5 className="flex items-center text-xl font-medium select-none text-nowrap gap-1">
                Minha assinatura
                <ChipStatusAssinatura />
            </h5>
            <div className="hidden md:inline-flex gap-2">
                {botoes.map(
                    ({ href, icon, label, show }, key) =>
                        show && (
                            <Button
                                href={href}
                                startIcon={icon}
                                variant="outlined"
                                key={key}
                            >
                                {label}
                            </Button>
                        ),
                )}
            </div>
            <Menu.Root className="md:hidden">
                <Menu.Trigger>
                    <Button
                        variant="outlined"
                        endIcon={<EllipsisVerticalIcon className="size-5" />}
                    >
                        Ações
                    </Button>
                </Menu.Trigger>
                <Menu.List>
                    {botoes.map(
                        ({ href, icon, label, show }, key) =>
                            show && (
                                <Menu.Item
                                    href={href}
                                    className="gap-2"
                                    key={key}
                                >
                                    {icon}
                                    {label}
                                </Menu.Item>
                            ),
                    )}
                </Menu.List>
            </Menu.Root>
        </div>
    )
}

function useBotoes() {
    const { assinatura, cliente } = usePlanosContext()

    return [
        {
            show:
                assinatura?.myId &&
                cliente?.myId &&
                ['active', 'waitingPayment'].includes(assinatura?.status),
            label: 'Alterar pagamento',
            icon: <CreditCardIcon className="size-5" />,
            href: `/planos/me/cobranca/${assinatura?.myId}/cartao`,
        },
        {
            show:
                !!assinatura?.myId &&
                ['active', 'waitingPayment'].includes(assinatura?.status),
            label: 'Cancelar plano',
            icon: <CircleXIcon className="size-5" />,
            href: `/planos/me/cobranca/${assinatura?.myId}/cancelar`,
        },
        {
            show: true,
            label: 'Todos os planos',
            icon: <ShoppingCartIcon className="size-5" />,
            href: '/planos',
        },
    ]
}
